import type { RouteObject } from 'react-router';

import { lazy, Suspense } from 'react';

import { MvpLayout } from 'src/layouts/mvp';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const MvpPage = lazy(() => import('src/pages/mvp'));

// ----------------------------------------------------------------------

const mvpLayout = () => (
  <MvpLayout>
    <Suspense fallback={<LoadingScreen />}>
      <MvpPage />
    </Suspense>
  </MvpLayout>
);

export const mvpRoutes: RouteObject[] = [
  {
    path: 'mvp',
    element: mvpLayout(),
  },
];
